import { clear } from '@testing-library/user-event/dist/clear'
import React, {useEffect, useRef, useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
function CanvasContent({bodyWidth, bodyHeight}) {

  //canvas functions from https://www.youtube.com/watch?v=FLESHMJ-bI0&ab_channel=MaksimIvanov
  const canvasRef = useRef()
  const radioShapeRef = useRef()
  const radioEffectRef = useRef()
  const contextRef = useRef()
  const canvasDivRef = useRef()
  const font = '"Terminal ", monospace'
  const [redVal, setRedVal] = useState(0)
  const [greenVal, setGreenVal] = useState(0)
  const [blueVal, setBlueVal] = useState(0)
  const [brushSize, setBrushSize] = useState(2)
  const [brushShape, setBrushShape] = useState('round')
  const [brushEffect, setBrushEffect] = useState('paint')
  const [transparency, setTransparency] = useState(100)
  const [isDrawing, setIsDrawing] = useState(false)
  const windowCheck = useSelector((state) => state.shower.window);
  
  // useEffect(() =>{
  //   const ctx = canvasRef.current.getContext("2d")
  // }, [])

  useEffect(() => {
    if(windowCheck.find((w) => w.windowID === 'canvas-window').reset){
      reset()
    }
  },[windowCheck.find((w) => w.windowID === 'canvas-window').reset])

  const reset = () => {
    setRedVal(0)
    setGreenVal(0)
    setBlueVal(0)
    setBrushSize(2)
    setTransparency(100)
    setBrushShape('round')
    setBrushEffect('paint')
    clearCanvas()
    document.getElementById('red').value = 0
    document.getElementById('green').value = 0
    document.getElementById('blue').value = 0
    document.getElementById('brushSize').value = 2
    document.getElementById('transparency').value = 100
  }

  const onRedInput = () => {
    var input = document.getElementById("red");
    var currentVal = input.value;
    setRedVal(currentVal)
  }

  const onGreenInput = () => {
    var input = document.getElementById("green");
    var currentVal = input.value;
    setGreenVal(currentVal)
  }

  const onBlueInput = () => {
    var input = document.getElementById("blue");
    var currentVal = input.value;
    setBlueVal(currentVal)
  }

  const onBrushSizeInput = () => {
    var input = document.getElementById("brushSize");
    var currentVal = input.value;
    setBrushSize(currentVal)
  }

  const onTransparencyInput = () => {
    var input = document.getElementById("transparency");
    var currentVal = input.value;
    setTransparency(currentVal)
  }

  const startStroke =(e) =>{
    setIsDrawing(true)
    const ctx = canvasRef.current.getContext("2d")
    ctx.beginPath();
    drawToCanvas(e)
  }

  const finishStroke =() =>{
    const context = canvasRef.current.getContext('2d');
    setIsDrawing(false);
    context.closePath();
    
  }

  const drawToCanvas =(e) =>{
    if(!isDrawing){
      return
    }
    
    if(brushEffect === 'paint'){
      const ctx = canvasRef.current.getContext("2d")
      ctx.lineWidth = brushSize
      ctx.strokeStyle = `rgba(${redVal},${greenVal},${blueVal}, ${transparency/100})`
      ctx.lineCap = brushShape
   
    //console.log(brushShape)
    //console.log(canvasRef.current.getBoundingClientRect());
      ctx.lineTo(e.clientX - canvasRef.current.getBoundingClientRect().x, e.clientY - canvasRef.current.getBoundingClientRect().y)
      ctx.stroke()
      ctx.beginPath()
      ctx.moveTo(e.clientX  - canvasRef.current.getBoundingClientRect().x, e.clientY- canvasRef.current.getBoundingClientRect().y)
    }else if(brushEffect === 'erase'){
      const ctx = canvasRef.current.getContext("2d")
      ctx.clearRect(e.clientX - canvasRef.current.getBoundingClientRect().x - brushSize/2, e.clientY - canvasRef.current.getBoundingClientRect().y - brushSize/2,
                    brushSize, brushSize)
    }
    
  }
  
  const updateBrushShape = (e) => {
    
    setBrushShape(e.target.value)
  }

  const updateBrushEffect = (e) => {
    setBrushEffect(e.target.value)
  }

  const clearCanvas =() =>{
    const context = canvasRef.current.getContext('2d');

    context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
  }
  return (
    <div id='canvas-content' style={{
      display: 'flex',
      flexFlow: 'column',
      //postion: 'relative',
      width: '100%',
      height: '100%',
      fontFamily: font,
    }}>
      <div id='canvas-config' style={{
        //marginTop: '1%',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexFlow: 'row',
      }}>
        <div id='color-selector-canvas' style={{
          display: 'flex',
          flexFlow: 'column',
        }}>
          <b>red:{redVal}</b>
          <input type="range" id="red" defaultValue={0} min="0" max="255" onInput={onRedInput}></input>
          <b>green:{greenVal}</b>
          <input type="range" id="green" defaultValue={0} min="0" max="255" onInput={onGreenInput}></input>
          <b>blue:{blueVal}</b>
          <input type="range" id="blue" defaultValue={0} min="0" max="255" onInput={onBlueInput}></input>
        </div>
        <div id='brush-color-white-bg' style={{
          marginTop: '15px',
          marginLeft: '2%',
          marginRight: '2%',
          width: '5%',
          height: '80%',
          backgroundColor: `rgb(255,255,255)`,
        }}>
          <div id='brush-color' style={{
          //marginTop: '15px',
          //marginLeft: '2%',
          //marginRight: '2%',
          width: '100%',
          height: '100%',
          backgroundColor: `rgb(${redVal},${greenVal},${blueVal})`,
        }}>

        </div>
        </div>
        <div id='brush-settings-selector'style={{
          display: 'flex',
          flexFlow: 'column',
        }}>
          <b>brush size:{brushSize}</b>
          <input type="range" id="brushSize" defaultValue={1} min="0" max="500" onInput={onBrushSizeInput}></input>
          
          <b>transparency:{transparency}</b>
          <input type="range" id="transparency" defaultValue={100} min="0" max="100" onInput={onTransparencyInput}></input>
        </div>
        <div id='brush-radio-settings-selector' style={{
          marginLeft: '2%',
          marginRight: '2%',
          //marginTop: '2%',
          display: 'flex',
          flexFlow: 'column',
        }}>
          <form>
            <fieldset ref={radioShapeRef} id='brush-shape'>
              <legend>Brush Shape</legend>
              <input type='radio' id='round-radio' value='round' name='brush-shape' checked={brushShape === 'round'}  onChange={updateBrushShape}/>
              <label htmlFor='round-radio'>Round</label>
              <input type='radio' id='square-radio' value='square' name='brush-shape' checked={brushShape === 'square'}  onChange={updateBrushShape}/>
              <label htmlFor='square-radio'>Square</label>
            </fieldset>

            <fieldset ref={radioEffectRef} id='brush-effect' >
              <legend>Brush Effect</legend>
              <input type='radio' id='bp-radio' value='paint' name='brush-effect' checked={brushEffect === 'paint'} onChange={updateBrushEffect}/>
              <label htmlFor='bp-radio'>Paint</label>
              <input type='radio' id='be-radio' value='erase' name='brush-effect' checked={brushEffect === 'erase'} onChange={updateBrushEffect}/>
              <label htmlFor='be-radio'>Erase (square brush only)</label>
            </fieldset>
          </form>
        </div>
        <div id='file-selector' style={{
          marginLeft: '2%',
          marginRight: '2%',
          marginTop: '2%',
          display: 'flex',
          flexFlow: 'column',
        }}>
          <button onClick={() => clearCanvas()} style={{
            fontFamily: font,
            backgroundColor:'rgb(76, 201, 240)',
            border: '2px outset rgb(76, 201, 240)',
            borderRadius: '5px', 
            cursor: 'pointer',
          }}>
            clear canvas
          </button>
        </div>
      </div>

      <canvas ref={canvasRef} width={bodyWidth*.95} height={bodyHeight*.8}  onMouseDownCapture={startStroke} onMouseLeave={finishStroke} onMouseUp={finishStroke} onMouseMove={drawToCanvas} style={{
        border: '2px solid black',
        margin: 'auto',
        //alignSelf: 'self-end',
        //height: '100%',
      }}>
          
      </canvas>

      
    </div>
  )
}

export default CanvasContent